<div
  class="radio-button-wrapper"
  [ngClass]="{
    'selected-radio-button-list-item': control?.value === value || selected,
    'radio-button-wrapper-background': !(control?.value === value || selected || transparentBackground),
    'radio-button-wrapper-hover': control?.value !== value && !disabled,
    'radio-button-disabled': disabled,
  }"
  [ngStyle]="{ 'column-gap': hideIcon ? 0 : '0.25rem' }"
  (click)="setRadioButton()"
>
  <div
    [ngClass]="{
      'ice-radio-button-hide-icon': hideIcon,
    }"
  >
    <mat-radio-button
      #radioButton
      class="radio-button-styles"
      [checked]="control?.value === value || selected"
      [disableRipple]="true"
      [disabled]="disabled"
      [value]="value"
      (click)="$event.preventDefault()"
    />
  </div>
  <div>
    <ng-content />
  </div>
</div>
